"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importDefault(require("react"));
require("./style.css");
var IconButton = function IconButton(_a) {
  var children = _a.children,
    _b = _a.disabled,
    disabled = _b === void 0 ? false : _b,
    onClick = _a.onClick,
    testID = _a.testID,
    title = _a.title;
  return react_1.default.createElement("div", {
    className: (0, clsx_1.default)('icon-button', disabled && 'icon-button--disabled'),
    "data-testid": testID,
    onClick: onClick,
    title: title
  }, children);
};
exports.default = IconButton;